import { useLayoutEffect, useEffect, useState, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { useLocation } from "react-router-dom";
// import { useEffect, useState } from "react";



// import Lottie from "lottie-react";

// import visualNdt from "../lottie/visual-testing.json";
// import liquidTesting from "../lottie/visual-testing.json";

// images
import card01 from "../assets/image/services/01DESIGN/Factory-Process-Layout.png"
import card02 from "../assets/image/services/01DESIGN/Hygienic-Design-.png"
import card03 from "../assets/image/services/01DESIGN/Sanitation-Procedures-.png"
import card04 from "../assets/image/services/02INFRASTRUCTURE/Metal-Structures.png"
import card05 from "../assets/image/services/02INFRASTRUCTURE/Hygienic-Materials.png"
import card06 from "../assets/image/services/02INFRASTRUCTURE/Process-Equipment.png"
import card07 from "../assets/image/services/02INFRASTRUCTURE/Sanitation-Equipment.png"
import card08 from "../assets/image/services/03MAINTENANCE/Sanitation-Tools.png"
import card09 from "../assets/image/services/03MAINTENANCE/Sanitation-Training.png"
import card10 from "../assets/image/services/03MAINTENANCE/Food-Safety-Audits.png"
import card11 from "../assets/image/services/03MAINTENANCE/CFS-Certification.png"
import card12 from "../assets/image/services/04CONTINUOUSIMPROVEMENTS/Digital-Food-Safety-Management.png"
import card13 from "../assets/image/services/04CONTINUOUSIMPROVEMENTS/Traceability.png"





const tabs = ["design", "infrastructure", "maintenance", "improvements"];

const services = [
{
no: "01.",
title:`DESIGN`,
subtitle:`Get it right before you build`,
description:`The most expensive problems in food processing are the ones designed in at the start. Our Design services ensure your facility is laid out for maximum hygiene, flow efficiency, and long-term operability — before a single bolt is tightened.`,
items: [
    {
      scr:card01,
    heading:`Factory & Process Layout`,
    text:`A poorly planned layout costs you every single day — in product holds, unnecessary labour movement, and contamination risk. We design facility and process layouts that eliminate bottlenecks, reduce cross-contamination zones, and squeeze more production out of every square metre. Our consulting partners bring 30+ years of global poultry processing experience from Brazil, USA, and beyond, giving you access to best practices that most Indian processors have never seen applied locally.`,
    benefit:`More birds processed per shift, less labour wasted in movement, fewer product holds.`
    },
    {
        scr:card02,
    heading:`Hygienic Design`,
    text:`Most equipment looks clean. Hygienic design means it actually is clean — and stays that way. We apply 10 principles of Hygienic Design, trained by Commercial Food Sanitation (CFS). That means no sandwich joints where bacteria can hide, no stagnant water pooling, no flat surfaces that catch debris, and no hollow spaces that harbour contaminated fluids. Every component we specify or fabricate is assessed against these principles.`,
    benefit:`Reduced risk of Listeria and Salmonella, faster washdown times, fewer failed audits.`
    },
    {
        scr:card03,
    heading:`Sanitation Procedures`,
    text:`Having the right equipment means nothing without the right procedures. We develop facility-specific sanitation SOPs that are practical, auditable, and aligned with international food safety standards. Our advisory team includes specialists with 18+ years in sanitation practices and food safety programme design.`,
    benefit:`Consistent sanitation outcomes, audit-ready documentation, reduced dependence on individual operator knowledge.`
    },    
]
},
{
no: "02.",
title:`INFRASTRUCTURE`,

 subtitle:`Build it to last. Build it to clean.`,
description:`Your physical infrastructure — the structures, materials, and equipment inside your facility — determines your hygiene baseline. We supply and install infrastructure that is built for the demands of a wet, high-throughput food processing environment.`,
    items: [
{
    scr:card04,     
  heading:`Metal Structures`,
text:`We work with partners operating a 100,000 sq.ft fabrication unit with modern equipment, with an established install base across India. Our structural solutions are engineered for hygienic environments — designed to be cleanable, corrosion-resistant, and structurally sound under the daily demands of a busy processing facility.`,
benefit:`Durable, low-maintenance structures that don't become a hygiene liability over time.`
},
{
  scr:card05,
  heading:`Hygienic Materials`,
text:`The wrong materials create the wrong problems — surface roughness that harbours bacteria, joints that trap moisture, coatings that degrade under washdown chemicals. We specify and supply hygienic wall and floor protection systems and materials engineered for cleanability and longevity in food processing environments.`,
benefit:`Improved facility longevity, easier cleaning, surfaces that hold up under daily washdown.`
},
{
  scr:card06,
  heading:`Process Equipment`,
text:`We source and supply high-performance poultry processing equipment from global partners, capable of handling up to 8,000+ birds per hour. Our equipment portfolio covers the full processing line — including smart grading solutions, integrated processing equipment, further processing solutions, spiral freezing, and intelligent process automation. Because we source globally, you get the best available technology for your specific line requirements, not just what one supplier happens to carry.`,
benefit:`Higher yield and consistency, optimised hygiene, line performance matched to your exact throughput targets.`
},
{
  scr:card07,
  heading:`Sanitation Equipment`,
text:`Cleaning a processing facility is a significant daily operation. We supply sanitation equipment from world-class partners — including best-in-class industrial cleaning solutions for conveyor belts, with particular strength in dry cleaning applications that reduce water usage and drying time.`,
benefit:`Faster, more effective cleaning cycles, reduced water consumption, lower risk of residual contamination.`
},    
]
},
{
no: "03.",
title:`MAINTENANCE`,

 subtitle:`Hygiene is a daily discipline, not a one-time project`,
description:`A facility that was designed and built well can still fail if the maintenance programme is weak. Our Maintenance services keep your team equipped, trained, certified, and accountable.`,
    items: [
{
    scr:card08,     
  heading:`Sanitation Tools`,
text:`We supply sanitation tools from a world leader in hygienic cleaning, featuring colour-coded segregation systems that prevent cross-contamination between zones. Every tool is designed with food safety in mind — not just cleaning performance, but the discipline and traceability that modern food safety programmes demand.`,
benefit:`Zone-specific hygiene control, reduced cross-contamination risk, tools that support a culture of food safety.`
},
{
  scr:card09,
  heading:`Sanitation Training`,
text:`Equipment and procedures are only as good as the people operating them. We provide hands-on sanitation training programmes covering hygienic design principles, correct cleaning techniques, and food safety awareness — drawing on our advisory team's deep experience in global sanitation practices.`,
benefit:`A trained, consistent workforce that doesn't rely on one or two key individuals to maintain hygiene standards.`
},
{
  scr:card10,
  heading:`Food Safety Audits`,
text:`We conduct structured food safety audits that give you an honest, expert view of where your facility stands and what needs to change. Our audits are grounded in international standards and delivered by specialists with real-world processing experience — not box-ticking consultants.`,
benefit:`Clear visibility of hygiene gaps before your customers or regulators find them, with a practical remediation plan.`    
},
{
  scr:card11,
  heading:`CFS Certification`,
text:`PthruP is trained and aligned with Commercial Food Sanitation (CFS), an Intralox company — one of the most respected names in food processing hygiene globally. We help facilities work towards CFS-aligned standards, giving you a credible, internationally recognised benchmark for your hygiene programme.`,
benefit:`A certification pathway that strengthens your brand, supports export ambitions, and gives major buyers confidence in your facility.`
},    
]
},
{
no: "04.",
title:`IMPROVEMENTS`,
 subtitle:`The best facilities never stand still`,
description:`Once your facility is designed, built, and running well, the focus shifts to improvement — tightening processes, reducing waste, and using data to drive decisions. We bring the digital tools and expertise to make that happen.`,
    items: [
      {
          scr:card12,     
        heading:`Traceability`,
      text:`In today's market, knowing where every product has been at every stage of processing is not optional — it is a commercial and regulatory requirement. We help you implement traceability systems that track product through your facility, giving you the data you need to respond to any food safety event quickly and with confidence.`,
      benefit:`Faster incident response, stronger customer and retailer confidence, compliance with traceability requirements.`
      },
      {
        scr:card13,
        heading:`Digital Food Safety Management`,
      text:`We bring digital food safety management to your facility. This means moving your safety and hygiene records off clipboards and into a live, auditable digital system that gives management real-time visibility and makes audits significantly easier to manage.`,
      benefit:`Real-time oversight of food safety performance, reduced paperwork burden, audit-ready data at your fingertips.`
      },  
    ]
}




];

gsap.registerPlugin(ScrollTrigger);

export default function PortfolioCards() {

const sectionRef = useRef();
const sectionRefs = useRef([]);
const location = useLocation();
const [activeTab, setActiveTab] = useState("design");

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const tab = params.get("tab");

  if (tab) {
    const index = tabs.indexOf(tab.toLowerCase());
    if (index !== -1) {
      setActiveTab(index);

      // scroll to section after small delay (important)
      setTimeout(() => {
        sectionRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }
}, [location.search]);



const handleTabClick = (index) => {
  setActiveTab(index);

  // update URL (IMPORTANT)
  const tabName = tabs[index];
  window.history.replaceState(null, "", `?tab=${tabName}`);

  sectionRefs.current[index]?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = sectionRefs.current.findIndex(
            (el) => el === entry.target
          );

          if (index !== -1) {
            setActiveTab((prev) => (prev !== index ? index : prev));
          }
        }
      });
    },
    {
      rootMargin: "-40% 0px -40% 0px",
    }
  );

  sectionRefs.current.forEach((section) => {
    if (section) observer.observe(section);
  });

  return () => observer.disconnect();
}, []);

useLayoutEffect(() => {
    const ctx = gsap.context(() => {
    gsap.utils.toArray(".service-frame").forEach((card) => {
    const wrapper = card.querySelector(".service-wrapper");

  gsap.fromTo(
    wrapper,
    {
      y: 120,
      rotateX: 120,   // starts leaning away
      scale: 0.94,
      opacity: 0
    },
    {
      y: 0,
      rotateX: 0, // 👈 final tilt from Webflow
      scale: 1,
      opacity: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: card,
        start: "top 80%",
        end: "top 30%",
        scrub: true
      }
    }
  );
});


    // ROWS PARALLAX (subtle horizontal drift)
      gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-2", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-2",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-3", {
        xPercent: -2,
        scrollTrigger: {
          trigger: ".is-row-3",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      // TEXT REVEAL (up & down alternating)
      gsap.from(".h2", {
        y: -120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%"
        }
      });

      gsap.from(".h2-stroke", {
        y: 120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%"
        }
      });
  

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="section is-overflow">
     <div className="container-tab">
   {tabs.map((tab, index) => (
  <div
    key={index}
    className={`tab-nav ${activeTab === index ? "active" : ""}`}
    onClick={() => handleTabClick(index)}
  >
    {tab.toUpperCase()}
  </div>
))}
</div>
     <div className="container-lg">

       {services.map((service, index) => (
<div key={index} ref={(el) => (sectionRefs.current[index] = el)} className="services--container service-plane">
  <div className="container-h container-grid-col">
    <div className="container-lg is-h-padded">
            {/* <div className="h-row is-row-1">
                <div className="h2-wrap">
                    <h2 className="h2"><b className="h2-stroke">{service.no}</b> {service.title}</h2>
                </div>
            </div> */}

            <div className="h-row is-row-1">
                <div className="h2-wrap">
                    <h3 className="h2 line-height-wrap">{service.subtitle}</h3>
                </div>
            </div>
        </div>


            <div className="container-lg is-h-padded is-mobile">
           
            <div className="h-row is-row-2">
                <div className="h2-wrap">
                    <h3 className="h2 line-height-wrap">{service.subtitle}</h3>
                </div>
            </div>
        </div>

        <div className="container-lg is-c-space">
            <div className="para-wrapper">
              <div className="d-50 is-mobile">
                <p className="text text-reveal">
               {service.description}
                </p>
              </div>
            </div>
          </div>
  </div>

    {service.items.map((item, i) => (      
    <div className={`service-frame service-frame-page is-${i}`} key={i}>
        <div className={`service-wrapper ${i % 2 === 0 ? "bg-black is-white" : ""}`}>
            <div className="flex-l-t is-serv-col-1">
                {/* <div className="big-no-wrapper">
                    <div className="big-no">01</div>
                </div> */}
                <div className="big-animation-wrapper bg-black">
                    <div className="big-animation">
                    <img src={item.scr} alt="services" />
                    </div>
                </div>
            </div>
            <div className="flex-v-l-split is-s-card-content">
                <div className="h2-frame">
                      {/* <div className="h2-wrap row-1">
                        <h4 className="h2 ">
                        {service.title}</h4>
                    </div> */}
                    <div className="h2--wrap row-1">
                        <h2 className="h2 line-height-wrap">
                        {item.heading}</h2>
                    </div>
                    <p className={`text d-80 mobile-max  is-margin-top ${i % 2 === 0 ? "txt-white" : ""}`}>
                        {item.text}
                    </p>
                      <div className={`divider-line ${i % 2 === 0 ? "txt-white" : ""}`}></div>
                      <div className="flex-r--s is-80">
 
                     <p className={`text d-80 mobile-max  ${i % 2 === 0 ? "txt-white" : ""}`}>
                         <strong>Customer Benefit:</strong> {item.benefit}
                    </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
 ))}
   </div>
  ))}       
     </div>   
    </section>
  );
}